import { axiosInstanceWithToken } from "@/utils/axios";
import { HOST_API_KEY } from "../../config";

export const createFeedback = async (data) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/feedback/create`, data);
  return request.data;
};

export const createFeedbackMedia = async (data) => {
  const request = await axiosInstanceWithToken.post(
    `${HOST_API_KEY}/feedback/media/create`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return request.data;
};

export const getAllFeedbacks = async () => {
  const request = await axiosInstanceWithToken.get(`${HOST_API_KEY}/feedback/_all`);
  return request.data;
};

export const getFeedbackById = async (feedbackId) => {
  const request = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/feedback/single/${feedbackId}`
  );
  return request.data;
};

export const getAllFeedbackStatus = async () => {
  const request = await axiosInstanceWithToken.get(`${HOST_API_KEY}/feedback/status/all`);
  return request.data;
};

export const updateFeedback = async (feedbackId, data) => {
  const request = await axiosInstanceWithToken.put(
    `${HOST_API_KEY}/feedback/update/${feedbackId}`,
    data
  );
  return request.data;
};
